import { getI18nMap, getI18nDefaultFormat } from './i18n'

const { REACT_APP_ENV } = process.env

export default (locale, retailerSlug) => {
  // eslint-disable-next-line no-bitwise
  const prefix = ~['dev', 'stg'].indexOf(REACT_APP_ENV) ? 'stg-' : ''
  const { ISO639, ISO3166_1 } = getI18nMap(getI18nDefaultFormat(locale))
  const country = `${ISO639}-${ISO3166_1.toLowerCase()}`
  return `//${prefix}${country}-media.shopfully.cloud/images/catene/segnalino_${retailerSlug}@2x.png`
}
